// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__2UPGS","description":"NotFoundBlock_description__fxmLK"};